import { AppContext, useActivityTracker } from '@nile/components';
import { Button } from '@superops/ui-design-system';
import React, { useContext, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { ACTIVATE_TRIAL_ADDON, AccountClient } from '@nile/graphql';
import { useMutation } from '@apollo/client';

interface StartTrialButtonProps {
  feature: string;
  addonId: string;
  buttonTextKey: string;
}

const StartTrialButton = ({
  feature,
  addonId,
  buttonTextKey
}: StartTrialButtonProps) => {
  const [activateTrialAddon, { loading: activatingTrial }] = useMutation(
    ACTIVATE_TRIAL_ADDON,
    {
      client: AccountClient,
      onCompleted: (data) => {
        useActivityTracker({
          event: `Trial activated - ${feature}`
        });
        if (data?.activateTrialAddon) {
          window.location.reload();
        }
      },
      onError: (err) => {
        console.error('Error activating trial:', err);
      }
    }
  );

  const handleStartTrial = async () => {
    if (!addonId) {
      console.error('No addon ID found in trialInfo');
      return;
    }

    useActivityTracker({
      event: `Trial activation initiated - ${feature}`
    });

    try {
      await activateTrialAddon({
        variables: { addonId }
      });
    } catch (err) {
      console.error('Error activating trial:', err);
    }
  };

  return (
    <div className="trial-button">
      <Button
        onClick={handleStartTrial}
        loading={activatingTrial}
        disabled={activatingTrial}
      >
        <FormattedMessage id={buttonTextKey || `Start free ${feature} trial`} />
      </Button>
    </div>
  );
};

export default StartTrialButton;
